import React from 'react'
import { connect, useSelector } from 'react-redux';
import DropDown from '../shared/Input/DropDown/DropDown';
import { setCurrentSeason } from '../../redux/slices/seasonSlice';

const SeasonDropDown = ({ updateCurrentSeason, darkTheme, setSeasonUpdating }) => {
  const { seasons, currentSeason } = useSelector((state) => state.seasons);
  const seasonOptions = seasons?.map((season) => ({
    value: season?._id, // Pass the season ID
    label: season?.seasonName, // Display the season name
  }));

  const handleSeasonChange = async(event) => {
    if(setSeasonUpdating) setSeasonUpdating(() => true)
    const selectedSeasonId = event.target.value; // Get selected season ID
    const selectedSeason = seasons.find(season => season?._id === selectedSeasonId);
    updateCurrentSeason(selectedSeason); // Dispatch the action to update the Redux state

    if(setSeasonUpdating) setSeasonUpdating(() => false);
  };

  if(seasonOptions?.length <= 1) {
    return null;
  }

  return (
    <DropDown 
      label="Select Season" 
      placeholder={"Select Season"}
      options={seasonOptions} 
      value={currentSeason?._id || ""} 
      onChange={handleSeasonChange}
      darkTheme={darkTheme}
    />
  )
}
const mapDispatchToProps = (dispatch) => ({
  updateCurrentSeason: (data) => dispatch(setCurrentSeason(data)),
});

export default connect(null, mapDispatchToProps)(SeasonDropDown);